import React from 'react';
import { Link } from 'react-router-dom';
import './home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faBullseye } from '@fortawesome/free-solid-svg-icons';

// Import images
import image1 from '../../assets/images/images1.JPEG';
import image2 from '../../assets/images/images2.JPEG';
import image3 from '../../assets/images/images3.JPEG';
import image4 from '../../assets/images/images3.JPEG';
import image5 from '../../assets/images/images5.JPEG';
import image6 from '../../assets/images/images6.JPEG';
import heroImage from '../../assets/images/images9.JPEG';

const Home = () => {
  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="homepage-hero" id="home">
        <div className="homepage-hero-background">
          <div
            className="homepage-hero-image"
            style={{ backgroundImage: `url(${heroImage})` }}
          ></div>
          <div className="homepage-hero-overlay"></div>
        </div>

        <div className="homepage-container">
          <div className="homepage-hero-content">
            <div className="homepage-hero-badge">
              <span>Empowering Tanzania Since 2023</span>
            </div>

            <h1 className="homepage-hero-title">
              <span className="homepage-hero-title-main">ITAMBUE</span>
              <span className="homepage-hero-title-sub">THAMANI YAKO</span>
            </h1>

            <p className="homepage-hero-description">
              Transforming lives through empowerment, education, and sustainable development.
              We champion women, girls, and children to become self-reliant leaders in their communities.
            </p>

            <div className="homepage-hero-stats">
              <div className="homepage-hero-stat">
                <span className="homepage-stat-number">500+</span>
                <span className="homepage-stat-label">Lives Impacted</span>
              </div>
              <div className="homepage-hero-stat">
                <span className="homepage-stat-number">10+</span>
                <span className="homepage-stat-label">Regions</span>
              </div>
              <div className="homepage-hero-stat">
                <span className="homepage-stat-number">25+</span>
                <span className="homepage-stat-label">Programs</span>
              </div>
            </div>

            <div className="homepage-hero-actions">
              <a href="/events" className="homepage-btn homepage-btn-primary">
                <span>Join Our Events</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ marginLeft: '8px' }}>
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
              <Link to="/support" className="homepage-btn homepage-btn-secondary">
                <span>Support Our Cause</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ marginLeft: '8px' }}>
                  <path d="M12 5V19M12 5L6 11M12 5L18 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link>
            </div>

            <div className="homepage-hero-scroll">
              <span>Scroll to Explore</span>
              <div className="homepage-scroll-indicator"></div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="homepage-about" id="about">
        <div className="homepage-container">
          <div className="homepage-section-title">
            <h2>About Us</h2>
            <p>
              Learn about our organization and what drives us to make a difference
            </p>
          </div>
          <div className="homepage-about-content">
            <div className="homepage-about-image" style={{ backgroundImage: `url(${image1})` }}></div>
            <div className="homepage-about-text">
              <h3>Who Are We</h3>
              <p>
                ITY Tanzania (ITAMBUE THAMANI YAKO) is a non-profit organization
                dedicated to empowering women, girls, and children across
                Tanzania. We believe in creating a society where every individual
                has the opportunity to thrive and realize their full potential.
              </p>
              <p>
                Since our establishment, we have worked tirelessly to provide
                support, resources, and platforms for those who need it most. Our
                programs focus on education, health, economic empowerment, and
                rights advocacy.
              </p>
              <div className="homepage-about-stats">
                <div className="homepage-stat-box">
                  <div className="homepage-stat-number">500+</div>
                  <div className="homepage-stat-text">Members</div>
                </div>
                <div className="homepage-stat-box">
                  <div className="homepage-stat-number">10+</div>
                  <div className="homepage-stat-text">Regions</div>
                </div>
                <div className="homepage-stat-box">
                  <div className="homepage-stat-number">25+</div>
                  <div className="homepage-stat-text">Programs</div>
                </div>
              </div>
              <br />
              <div style={{ textAlign: 'center' }}>
                <a
                  href="#about"
                  className="homepage-btn"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '14px 32px',
                    backgroundColor: 'var(--primary)',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '50px',
                    fontWeight: '600',
                    fontSize: '1rem',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    border: '2px solid var(--primary)',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 8px 25px rgba(39, 163, 137, 0.3)',
                    minHeight: '52px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = 'var(--primary)';
                    e.target.style.transform = 'translateY(-3px)';
                    e.target.style.boxShadow = '0 12px 35px rgba(39, 163, 137, 0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = 'var(--primary)';
                    e.target.style.color = 'white';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 8px 25px rgba(39, 163, 137, 0.3)';
                  }}
                >
                  Join Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="homepage-vision-mission" id="vision">
        <div className="homepage-container">
          <div className="homepage-section-title">
            <h2>Our Vision & Mission</h2>
            <p>Guiding principles that drive our work every day</p>
          </div>
          <div className="homepage-vm-content">
            <div className="homepage-vm-card">
              <div className="homepage-vm-card-icon">
                <FontAwesomeIcon icon={faEye} />
              </div>
              <h3>Vision Statement</h3>
              <p>
                The vision of The Organization is to see better living of the
                women, girls and children and enjoy their rights just like other
                people.
              </p>
            </div>
            <div className="homepage-vm-card homepage-mission">
              <div className="homepage-vm-card-icon">
                <FontAwesomeIcon icon={faBullseye} />
              </div>
              <h3>Mission Statement</h3>
              <p>
               Empowering Women, Girls and Children to meet their rights and become
                self reliant and esteemed.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Objectives Section */}
      <section className="homepage-objectives" id="objectives">
        <div className="homepage-container">
          <div className="homepage-section-title">
            <h2>Our Objectives</h2>
            <p>The core goals that guide our initiatives and programs</p>
          </div>
          <div className="homepage-objectives-grid">
            <div className="homepage-objective-card">
              <span className="homepage-objective-number">1</span>
              <p>
                To Empower women girls and children on becoming self reliant and
                esteemed other rural majority.
              </p>
            </div>
            <div className="homepage-objective-card">
              <span className="homepage-objective-number">2</span>
              <p>
                To conduct various platforms of women girls and children to
                discuss their challenges and how they can overcome.
              </p>
            </div>
            <div className="homepage-objective-card">
              <span className="homepage-objective-number">3</span>
              <p>
                To link women, girls and children with various relevant for access
                opportunities and support for their needs.
              </p>
            </div>
            <div className="homepage-objective-card">
              <span className="homepage-objective-number">4</span>
              <p>To advocate for women, girls and children rights.</p>
            </div>
            <div className="homepage-objective-card">
              <span className="homepage-objective-number">5</span>
              <p>To promote women, girls and children capacity and creativity.</p>
            </div>
            <div className="homepage-objective-card">
              <span className="homepage-objective-number">6</span>
              <p>
                To enhance and promote health, education, social economic
                development.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="homepage-gallery" id="gallery">
        <div className="homepage-container">
          <div className="homepage-section-title">
            <h2>Our Gallery</h2>
            <p>Moments from our community initiatives and programs</p>
          </div>
          <div className="homepage-gallery-grid">
            <div className="homepage-gallery-item" style={{ backgroundImage: `url(${image1})` }}>
              <div className="homepage-gallery-caption">Community Outreach Program</div>
            </div>
            <div className="homepage-gallery-item" style={{ backgroundImage: `url(${image2})` }}>
              <div className="homepage-gallery-caption">Women's Empowerment Workshop</div>
            </div>
            <div className="homepage-gallery-item" style={{ backgroundImage: `url(${image3})` }}>
              <div className="homepage-gallery-caption">Children's Education Initiative</div>
            </div>
            <div className="homepage-gallery-item" style={{ backgroundImage: `url(${image4})` }}>
              <div className="homepage-gallery-caption">Health Awareness Campaign</div>
            </div>
            <div className="homepage-gallery-item" style={{ backgroundImage: `url(${image5})` }}>
              <div className="homepage-gallery-caption">Skills Training Session</div>
            </div>
            <div className="homepage-gallery-item" style={{ backgroundImage: `url(${image6})` }}>
              <div className="homepage-gallery-caption">Community Celebration</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;